// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".change-list-scroll {\n    padding-right: 5px;\n}\n\n.change-list-scroll::-webkit-scrollbar {\n    width: 12px;\n    height: 12px;    \n}\n  \n.change-list-scroll::-webkit-scrollbar-thumb {\n    background: gray;\n    border-radius: 10px;\n    height: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
